<div class="row">
  <div class="col-12">
    <div class="full-screen-message body-login">
      <div class="full-screen-message-container fsm-txt-container">
        <ng-container *ngIf="useChangePasswordForm; else useResetPasswordForm">
          <app-change-password-form></app-change-password-form>
        </ng-container>
        <ng-template #useResetPasswordForm>
          <app-reset-password-form></app-reset-password-form>
        </ng-template>
      </div>
    </div>
  </div>
  <!-- Col -->
</div>
<!-- Row -->
